// extracted by mini-css-extract-plugin
export var rssCategories = "rss-parser-module--rss-categories--ca947";
export var rssContent = "rss-parser-module--rss-content--6d7c9";
export var rssImage = "rss-parser-module--rss-image--3a071";
export var rssTitle = "rss-parser-module--rss-title--5c36a";